export default __webpack_public_path__ + "static/media/guesty.f2c83378.png";